import { render, staticRenderFns } from "./FloorView.vue?vue&type=template&id=53899b4d"
import script from "./FloorView.vue?vue&type=script&lang=js"
export * from "./FloorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports